import { create } from 'zustand';

interface Execution {
  profileId: string
  executionTime: number // timestamp in ms
}

interface ExecutionState {
  cooldown: number
  executions: Execution[]
  setCooldown: (value: number | ((prev: number) => number)) => void
  setExecution: (profileId: string, executionTime: number) => void
  getExecutionTime: (profileId: string) => number | undefined
}

export const useExecutionStore = create<ExecutionState>((set, get) => ({
  cooldown: 0,
  executions: [],
  setCooldown: (value) => {
		set((state) => ({
			cooldown:
				typeof value === 'function'
					? value(state.cooldown)
					: value,
		}))
  },
  setExecution: (profileId, executionTime) => {
    set((state) => {
      const filtered = state.executions.filter(e => e.profileId !== profileId)
      return {
        executions: [...filtered, { profileId, executionTime }].slice(-4),
      }
    })
  },
  getExecutionTime: (profileId) => {
    return get().executions.find(e => e.profileId === profileId)?.executionTime
  },
}))
